export default __webpack_public_path__ + "static/media/solucao-09.7870932f.webp";